<template>
  <div class="tools collapse" :data-collapsed="collapsed">
    <collapse-header :title="title" :defaultCollapse="defaultCollapse" @collapse="collapse"/>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import CollapseHeader from '@/components/tools/collapse/Header'
export default {
  name: 'ToolsCollapse',
  components: { CollapseHeader },
  props: {
    title: String,
    defaultCollapse: Boolean
  },
  data () {
    return {
      collapsed: this.defaultCollapse
    }
  },
  methods: {
    collapse (value) { this.collapsed = value }
  }
}
</script>

<style>
  .tools.collapse{
    display:flex;
    flex-direction:column;
    margin:0 10px;
    background-color:var(--color-primary-bg);
    color:var(--color-primary);
    border-radius:4px;
    margin-bottom:10px;
    transition:all .5s ease-in-out
  }
  .tools.collapse > .content{
    flex:1 1 auto;
    transition:all .5s ease-in-out;
    overflow:hidden;
    margin:0 5px 5px 5px
  }
  .tools.collapse[data-collapsed="true"]{
    background-color:var(--color-disable-bg);
    color:var(--color-disable)
  }
  .tools.collapse[data-collapsed="true"] > .content{
    flex:0 0 0;
    margin-bottom:0
  }
</style>
